(function () {
  const content = document.querySelector('.article-template__content');
  const nav = document.getElementById('toc-list');
  const toggle = document.querySelector('.article-template__toc-toggle');
  const aside = document.getElementById('article-toc');
  if (!content || !nav) return;

  // Gather H2 headings from article content
  const headings = content.querySelectorAll('h2');
  if (headings.length < 2) {
    // Hide TOC if fewer than 2 headings
    if (aside) aside.style.display = 'none';
    return;
  }

  // Build TOC list
  const ol = document.createElement('ol');
  ol.className = 'article-template__toc-list';
  headings.forEach(function (h, i) {
    if (!h.id) h.id = 'heading-' + i;
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    a.className = 'article-template__toc-link';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      h.scrollIntoView({ behavior: 'smooth' });
      history.replaceState(null, '', '#' + h.id);
    });
    li.appendChild(a);
    ol.appendChild(li);
  });
  nav.appendChild(ol);

  // Intersection Observer for active heading
  var currentActive = null;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;
          var link = nav.querySelector('a[href="#' + id + '"]');
          if (currentActive) currentActive.classList.remove('is-active');
          if (link) {
            link.classList.add('is-active');
            currentActive = link;
          }
        }
      });
    },
    { rootMargin: '-80px 0px -70% 0px', threshold: 0 }
  );
  headings.forEach(function (h) { observer.observe(h); });

  // Mobile toggle
  if (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open');
    });
  }
})();
